<template>
  <nav
    id="shipments-page-header"
  >
    <ShipmentsPageFilterComponent
      :filters="localShipmentsFilter"
      @[ShipmentsPageFilter.Events.Updated]="onFilterUpdate"
    />
  </nav>

  <ShipmentsRegistry
    :params="registryParams"
  />
</template>

<script lang="ts">
import ShipmentsService from "@/domains/Shipments/ShipmentsService";
import ShipmentsPageFilterComponent
  from "@/domains/Shipments/components/ShipmentsPageFilter/ShipmentsPageFilterComponent.vue";
import ShipmentsPageFilter
  from "@/domains/Shipments/components/ShipmentsPageFilter/ShipmentsPageFilter";
import ShipmentsRegistry
  from "@/domains/Shipments/components/ShipmentsRegistry/ShipmentsRegistry.vue";

export default defineComponent({
  name: 'ShipmentsPage',
  components: {
    ShipmentsRegistry,
    ShipmentsPageFilterComponent
  },

  setup() {
    return {
      ShipmentsPageFilter
    }
  },

  data() {
    return {
      localShipmentsFilter: ShipmentsPageFilter.fromLocalStorage(),
    }
  },

  computed: {
    registryParams(): Parameters<typeof ShipmentsService.getListPaginated>[0] {
      const result: Parameters<typeof ShipmentsService.getListPaginated>[0] = {};
      Object.assign(result, this.localShipmentsFilter.getRequestParams());
      return result;
    }
  },

  methods: {
    onFilterUpdate(newFilter: ShipmentsPageFilter): void {
      this.localShipmentsFilter = newFilter;
    }
  }
});
</script>
